<template>
  <div class="packages-list">
    <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @submit="handleSearch" @submit.native.prevent>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="站点">
                <station-select type="input" v-model="search.station" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="单号">
                <a-input placeholder="输入单号(支持模糊查询)" v-model="search.code" allowClear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-model-item label="电话">
                <a-input placeholder="输入电话" v-model="search.phone" allowClear/>
              </a-form-model-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-model-item label="取件码">
                  <a-input placeholder="输入取件码" v-model="search.secret" allowClear/>
                </a-form-model-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-model-item label="状态" style="width: 100%;">
                  <a-select v-model="search.status" placeholder="选择状态" allowClear style="width: 160px;">
                    <a-select-option value="0">未取</a-select-option>
                    <a-select-option value="1">已取</a-select-option>
                    <a-select-option value="2">撤回</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-model-item label="电话">
                  <a-input placeholder="输入快递员电话" v-model="search['partner.mobile']" allowClear/>
                </a-form-model-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-model-item label="编号">
                  <a-input placeholder="输入格子编号" v-model="search['cabinet.serial']" allowClear/>
                </a-form-model-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-model-item label="公司">
                  <company-search
                      v-model="search.company"
                      placeholder="请选择所属公司"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-model-item label="入站时间">
                  <a-range-picker
                    v-model="intimeRange"
                    format="YYYY-MM-DD"
                    valueFormat="YYYY-MM-DD"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-model-item label="出站时间">
                  <a-range-picker
                    v-model="outttimeRange"
                    format="YYYY-MM-DD"
                    valueFormat="YYYY-MM-DD"
                  />
                </a-form-model-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" html-type="submit">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetSearchForm">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-divider />
      <a-table
          :loading="listloading"
          :columns="columns"
          :data-source="list"
          rowKey="_id"
          :scroll="{ x: 1700, y: 600 }"
          :pagination="pager"
          @change="change">
        <span slot="partner" slot-scope="text, record">
          <excom-icon :excom="record.partner.pinyin" :text="record.partner.name" />
          {{ record.partner.mobile }}
        </span>
        <span slot="code" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">
              {{ record.code }}
            </template>
            <a @click="openKuaid100(record.partner.pinyin, record.code)">{{ record.code }}</a>
          </a-tooltip>
        </span>
        <span slot="status" slot-scope="text">
          <span v-if="text === 1">
            <a-badge status="success" />已取
          </span>
          <span v-if="text === 0">
            <a-badge status="processing" />未取
          </span>
          <span v-if="text === 2">
            <a-badge status="warning" />撤回
          </span>
        </span>
        <span slot="phone" slot-scope="text,record">
          <span class="phone-edit">
            <span>{{ text }}</span>
            <a-icon type="edit" @click="modifyPhone(record._id, text)" />
          </span>
        </span>
        <span slot="mtype" slot-scope="text, record">
          <span v-if="record.mtype === '0'">
            <a-icon type="mail" style="color: blue" />
            短信
          </span>
          <span v-if="record.mtype === '1'">
            <a-icon type="message" style="color: green" />
            微信
          </span>
          <span v-if="record.mtype === '11'" @click="smsResend(record._id)">
            <a-icon type="info-circle" style="color: red" />
            发送失败
          </span>
          <span v-if="record.mtype === '9'">
            <a-icon type="clock-circle" style="color: red" />
            等等发送
          </span>

        </span>
        <span slot="action" slot-scope="text, record">
          <a-popconfirm
            title="你确定要开箱么?"
            ok-text="确定"
            cancel-text="放弃"
            @confirm="openBox(record._id)"
            v-if="record.status === 0"
          >
            <a-button style="padding: 0" type="link">开箱</a-button>
          </a-popconfirm>
          <a-button v-else style="padding: 0" type="link" :disabled="record.status !== 0">开箱</a-button>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              更多<a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-button
                  type="link"
                  icon="rollback"
                  :disabled="record.status === 0"
                  @click="inboundAgainAction(record._id)"
                  size="small"
                >重新入站</a-button>
              </a-menu-item>
              <a-menu-item>
                <a-button
                  type="link"
                  icon="check"
                  :disabled="record.status === 1 && record.freeOfCharge"
                  @click="freeCharge(record._id)"
                  size="small"
                >超期免单</a-button>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </a-card>
    <a-modal
      title="修改收件人电话"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="modifyPhoneSubmit"
      @cancel="handleCancel"
    >
      <a-form :form="modifyPhoneForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-form-item label="通知发送">
          <a-radio-group name="radioGroup" :default-value="1" v-model="modifyPhoneForm.sendNotice">
            <a-radio :value="1">发送信息</a-radio>
            <a-radio :value="0">不发送信息</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="修改的电话">
          <a-input v-model="modifyPhoneForm.phone"  />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import {
  historyPackageList,
  modifyPackage,
  packageOpenBox,
  inboundAgain,
  resendSms,
  setFreeOfCharge,
} from '@/api/bussiness';

const columns = [
  {
    title: '#',
    dataIndex: 'index',
    customRender: (text, row, index) => index + 1,
    key: 'index',
    width: '50px',
  },
  {
    title: '公司名称',
    dataIndex: 'company.name',
    key: 'companyName',
    ellipsis: true,
  },
  {
    title: '站点名称',
    dataIndex: 'station.name',
    key: 'stationName',
    width: 130,
    ellipsis: true,
  },
  {
    title: '单号',
    dataIndex: 'code',
    key: 'code',
    width: 150,
    ellipsis: true,
    scopedSlots: { customRender: 'code' },
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    ellipsis: true,
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '电话',
    dataIndex: 'phone',
    key: 'phone',
    width: 150,
    scopedSlots: { customRender: 'phone' },
  },
  {
    title: '取件码',
    dataIndex: 'secret',
    key: 'secret',
  },
  {
    title: '信息状态',
    dataIndex: 'mtype',
    key: 'mtype',
    width: 120,
    scopedSlots: { customRender: 'mtype' },
  },
  {
    title: '快递员',
    dataIndex: 'partner.name',
    key: 'partnerName',
    width: 120,
    scopedSlots: { customRender: 'partner' },
  },
  {
    title: '单价',
    dataIndex: 'unitprice',
    key: 'unitprice',
  },
  {
    title: '编号',
    dataIndex: 'cabinet.serial',
    key: 'cabinetSerial',
  },
  {
    title: '投递时间',
    dataIndex: 'intime',
    width: 120,
    key: 'intime',
  },
  {
    title: '取件时间',
    dataIndex: 'outtime',
    key: 'outtime',
  },
  {
    title: '备注',
    key: 'desc',
    dataIndex: 'desc',
  },
  // {
  //   title: '操作',
  //   key: 'action',
  //   fixed: 'right',
  //   width: 140,
  //   scopedSlots: { customRender: 'action' },
  // },
];
export default {
  data() {
    return {
      columns,
      visible: false,
      confirmLoading: false,
      modifyPhoneForm: {},
      listloading: false,
      search: {},
      id: '',
      list: [],
      pager: {},
      intimeRange: [],
      outttimeRange: [],
      advanced: false,
    };
  },
  created() {
    this.search = this.$route.query;
    this.getList();
  },
  computed: {
  },
  methods: {
    async getList() {
      this.listloading = true;
      try {
        const { data: { docs, pager } } = await historyPackageList({
          ...this.search,
          intimeStart: this.intimeRange[0],
          intimeEnd: this.intimeRange[1],
          outtimeStart: this.outttimeRange[0],
          outtimeEnd: this.outttimeRange[1],
        });
        this.list = docs;
        this.pager = {
          ...pager,
          showTotal: (total) => `共计 ${total} 条信息`,
        };
      } catch (e) {
        console.error(e);
      }
      this.listloading = false;
    },
    change(pagination) {
      this.search.page = pagination.current;
      this.getList();
    },
    handleSearch() {
      this.search.page = 1;
      this.getList();
    },
    modifyPhone(id, phone) {
      this.visible = true;
      this.id = id;
      this.modifyPhoneForm.phone = phone;
    },
    handleCancel() {
      this.visible = false;
    },
    async modifyPhoneSubmit() {
      const postData = this.modifyPhoneForm;
      this.confirmLoading = true;
      const { data } = await modifyPackage(this.id, postData);
      if (data) {
        this.$message.success('修改成功');
        this.handleCancel();
        this.getList();
      }
      this.confirmLoading = false;
    },
    async openBox(id) {
      const hide = this.$message.loading('开箱中请等待..', 0);
      const res = await packageOpenBox(id);
      if (res.data && res.data.success) {
        this.$message.success('开箱成功');
      } else {
        this.$message.error(res.data.msg);
      }
      hide();
      this.getList();
    },
    async inboundAgainAction(id) {
      await inboundAgain(id);
      this.$message.success('操作成功');
      this.getList();
    },
    openKuaid100(pinyin, code) {
      const url = `https://www.kuaidi100.com/chaxun?com=${pinyin}&nu=${code}`;
      window.open(url, '物流信息查询', 'location=no,channelmode=yes,width=800,height=800');
    },
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    async smsResend(id) {
      await resendSms(id);
      this.$message.success('操作成功');
      this.getList();
    },
    async freeCharge(id) {
      await setFreeOfCharge(id);
      this.$message.success('操作成功');
      this.getList();
    },
    resetSearchForm() {
      this.search = {
      };
      this.intimeRange = [];
      this.outtimeRange = [];
    },
  },
};
</script>
<style lang="less">
.phone-edit{
  .anticon{
    visibility: hidden;
    cursor: pointer;
    margin-left: 10px;
    &:hover{
      color: #2f54eb;
    }
  }
  &:hover{
    .anticon{
      visibility: visible;
    }
  }
}
</style>
